/**
 * Resolve a file from `public/` for the current Vite `base`.
 * Absolute `/sprites/...` paths break on itch.io (game lives under a subpath).
 */
export function assetUrl(path: string): string {
  const cleaned = path.replace(/^\//, "");
  return `${import.meta.env.BASE_URL}${cleaned}`;
}
